import { render, staticRenderFns } from "./CustomizableForm.vue?vue&type=template&id=1c64c1c9&scoped=true&name=customizable-form&"
import script from "./CustomizableForm.vue?vue&type=script&lang=js&"
export * from "./CustomizableForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomizableForm.vue?vue&type=style&index=0&id=1c64c1c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c64c1c9",
  null
  
)

export default component.exports